import store from "@/store";

// 按钮权限 disabled
const ButtonPermissionsDisabled= {
    beforeMount(el, binding) {
        const { value } = binding
        const all_permission = "*:*:*";
        const permissions = store.getters && store.getters.permissions

        if (value && value instanceof Array && value.length > 0) {
            const permissionFlag = value

            const hasPermissions = permissions.some(permission => {
                return all_permission === permission || permissionFlag.includes(permission)
            })

            if (!hasPermissions) {
                el.setAttribute('disabled',true)
                el.classList.add("is-disabled")
            }
        } else {
            throw new Error(`请设置操作权限标签值`)
        }
    },
}
// 按钮权限 hide
const ButtonPermissionsHide= {
    mounted(el, binding) {
        const { value } = binding
        const all_permission = "*:*:*";
        const permissions = store.getters && store.getters.permissions

        if (value && value instanceof Array && value.length > 0) {
            const permissionFlag = value

            const hasPermissions = permissions.some(permission => {
                return all_permission === permission || permissionFlag.includes(permission)
            })

            if (!hasPermissions) {
                el.parentNode && el.parentNode.removeChild(el)
            }
        } else {
            throw new Error(`请设置操作权限标签值`)
        }
    }
}

export default {
    ButtonPermissionsDisabled,
    ButtonPermissionsHide,
}
